/**
 * Account rules shared by the Service (register validation) and the Editor
 * forms (spec 001), so the client and the server cannot disagree.
 */

/** Minimum password length, enforced by `POST /auth/register` and the Register form. */
export const PASSWORD_MIN_LENGTH = 8;

/** Maximum password length (bcrypt input; the column stores the hash). */
export const PASSWORD_MAX_LENGTH = 255;

/** Maximum email length (`User.email` is varchar(255)). */
export const EMAIL_MAX_LENGTH = 255;

/** Trimmed and lower-cased: the one form an email is stored and matched in. */
export function normalizeEmail(email: string): string {
  return email.trim().toLowerCase();
}

/** `local@domain.tld`: no whitespace, one `@`, a dot in the domain with text either side. */
export function isValidEmail(email: string): boolean {
  return /^[^\s@]+@[^\s@.]+(\.[^\s@.]+)+$/.test(email);
}
